// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".chat-message[data-v-62bc5e17]{max-width:98%}.loading-username[data-v-62bc5e17]{display:inline-block;width:50px}.loading-username[data-v-62bc5e17] .v-skeleton-loader__text{margin-bottom:0}.message-text[data-v-62bc5e17]{word-wrap:break-word;word-break:break-word}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
